import { Component, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '../../../../shared/shared.module';
import { CustomerService } from '../../../../services/customer.service';
import { HrmsService } from '../../../../services/hrms.service';
import { gridPageRequest } from '../../../../model/common/common.model';
import { Employee } from '../../../../model/hrms/attendance.model';
import { MultiSelectModule } from 'primeng/multiselect';
import { FieldsetModule } from 'primeng/fieldset';
import { getISTDateWithCurrentTime } from '../../../../utils/date-utils';


@Component({
  selector: 'app-employee-component',
  standalone: true,
  imports: [SharedModule, CommonModule, MultiSelectModule, FieldsetModule],
  templateUrl: './employee-component.component.html',
  styleUrls: ['./employee-component.component.scss']

})
export class EmployeeComponent implements OnInit {
  empId: any;
  isEditMode = false;
  employeeList: any[] = [];
  DesignationList: any[] = [];
  locations: any[] = [];
  unitLocations: any[] = [];

  workLocationTypeOptions = [
    { label: 'Office', value: 'Office' },
    { label: 'Unit', value: 'Unit' },
    { label: 'Remote', value: 'Remote' }
  ];

  constructor(
    private employeeService: HrmsService,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public config: DynamicDialogConfig,
    private messageService: MessageService,
    private customerService: CustomerService,
    private router: Router, private routers: ActivatedRoute

  ) { }

  submitted = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  employeeDetails: Employee[] = [];
  selectedType: string | null = null;
  shiftDropdown: any[] = [];
  designationOptions: any[] = [];


  employeeTypeOptions = [
    { label: 'Full Time', value: 'Full Time' },
    { label: 'Part Time', value: 'Part Time' },
    { label: 'Contract', value: 'Contract' },
    { label: 'Temporary', value: 'Temporary' },
    { label: 'Internship', value: 'Internship' },
    { label: 'Freelance', value: 'Freelance' }
  ];

  employeeStatusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Resigned', value: 'Resigned' },
    { label: 'Terminated', value: 'Terminated' }
  ];

  prefixOptions = [
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Mrs.', value: 'Mrs.' },
    { label: 'Miss', value: 'Miss' }
  ];

  today: Date = new Date();


  gender = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' }
  ];

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 200,
    id: 0
  }

  employeeForm = new FormGroup({
    // Basic Information
    employeeId: new FormControl('', Validators.required),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', Validators.required),
      country: new FormControl('India', Validators.required),
    }),
    phone: new FormControl('', Validators.pattern(/^\d{10}$/)),
    mobile: new FormControl('', Validators.pattern(/^\d{10}$/)),
    prefix: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    // Work Information
    designation: new FormControl(''),
    jobRole: new FormControl(''),
    work_Email: new FormControl('', Validators.email),
    employmentType: new FormControl(''),
    employeeStatus: new FormControl(''),
    location: new FormControl(''),
    dateOfJoining: new FormControl<Date | null>(null),
    reportingManager: new FormControl<number[]>([]),
    gender: new FormControl(''),
    dob: new FormControl<Date | null>(null),
    website: new FormControl(''),
    facebook: new FormControl(''),
    twitter: new FormControl(''),
    // Education Details
    instituteName: new FormControl(''),
    degree: new FormControl(''),
    specialization: new FormControl(''),
    completionYear: new FormControl(''),
    internalNotes: new FormControl(''),
    IsActive: new FormControl(true),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
    ShiftId: new FormControl<number | string | null>(null),
    ShiftName: new FormControl(''),
    workLocationType: new FormControl<string | null>(null),
    assignedLocationIds: new FormControl<number[]>([]),
  });

  ngOnInit(): void {
    document.title = 'Create Employee';
    this.employeeForm.controls.CreatedBy.setValue(localStorage.getItem('username'));

    this.loadLocations();
    this.getStateList();
    this.getShift();
    this.getDesignation();

    this.employeeService.getEmployees(this.pageRequest).subscribe({
      next: (res: any) => {
        this.employeeList = (res?.employees || []).map((emp: any) => ({
          label: `${emp.firstName} ${emp.lastName}`,
          value: emp.empId
        }));

        this.routers.queryParams.subscribe((params: any) => {
          const empId = params['empId'];
          if (empId) {
            document.title = 'Update Employee';
            this.isEditMode = true;
            this.empId = Number(empId);

            this.employeeService.getEmployeeByID(this.empId).subscribe({
              next: (employee) => {
                this.patchEmployee(employee);
                this.loadEmployeeLocations(this.empId);
              },
              error: () => this.router.navigate(['/home/employee-info'])
            });
          }
        });
      }
    });
  }

  patchEmployee(employee: Employee): void {
    this.employeeForm.patchValue({
      employeeId: employee.employeeId,
      firstName: employee.firstName,
      lastName: employee.lastName,
      prefix: employee.prefix,
      email: employee.email,
      phone: employee.phone,
      mobile: employee.mobile,
      address: {
        addressLine1: employee.address?.addressLine1 || '',
        addressLine2: employee.address?.addressLine2 || '',
        city: employee.address?.city || '',
        state: employee.address?.state || '',
        zip: employee.address?.zip || '',
        country: employee.address?.country || 'India',
      },

      designation: employee.designation,
      jobRole: employee.jobRole,
      work_Email: employee.work_Email,
      employmentType: employee.employmentType,
      employeeStatus: employee.employeeStatus,
      location: employee.location,
      dateOfJoining: employee.dateOfJoining ? new Date(employee.dateOfJoining) : null,
      gender: employee.gender,
      dob: employee.dob ? new Date(employee.dob) : null,
      website: employee.website,
      facebook: employee.facebook,
      twitter: employee.twitter,
      instituteName: employee.instituteName,
      degree: employee.degree,
      specialization: employee.specialization,
      completionYear: employee.completionYear,
      internalNotes: employee.internalNotes,
      ShiftId: employee.shiftId,
      ShiftName: employee.shiftName,
      workLocationType: employee.workLocationType || null,
    });

    if (employee.reportingManager) {
      const managerIds = employee.reportingManager.split(',').map(Number);
      const selected = this.employeeList
        .filter(e => managerIds.includes(e.value))
        .map(e => e.value);
      this.employeeForm.controls.reportingManager.setValue(selected);
    }
  }


  loadEmployeeLocations(empId: number): void {
    this.employeeService.getEmployeeLocations(empId).subscribe({
      next: (data: any[]) => {
        if (!data?.length) {
          this.employeeForm.controls.assignedLocationIds.setValue([]);
          return;
        }

        const first = data[0];
        const workType = first.workLocationType || null;

        if (workType) {
          this.employeeForm.controls.workLocationType.setValue(workType);
        }

        if (workType === 'Unit') {
          const ids = data
            .filter((x: any) => x.workLocationType === 'Unit' && (x.locationId || x.LocationId))
            .map((x: any) => Number(x.locationId || x.LocationId))
            .filter((id: number) => !isNaN(id) && id > 0);
          this.employeeForm.controls.assignedLocationIds.setValue(ids);
        } else {
          this.employeeForm.controls.assignedLocationIds.setValue([]);
        }
      },
      error: err => {
        console.error('Failed to load employee locations:', err);
      }
    });
  }

  onWorkLocationTypeChange(_event: any): void {
    this.employeeForm.controls.assignedLocationIds.setValue([]);
  }

  onSubmit(): void {
    if (this.isEditMode) {
      this.updateEmployee(this.employeeForm.value);
    } else {
      this.createEmployee(this.employeeForm.value);
    }
  }


  createEmployee(data: any): void {
    this.submitted = true;
    if (!this.validateForm()) return;

    const workLocationType = data.workLocationType || null;
    const assignedLocationIds = data.assignedLocationIds || [];

    if (data.dob) data.dob = this.getDateOfBirth(data.dob);
    data.dateOfJoining = getISTDateWithCurrentTime(data.dateOfJoining);
    data.IsActive = true;
    data.WorkLocationType = workLocationType;

    if (Array.isArray(data.reportingManager)) {
      data.reportingManagers = data.reportingManager;
    }

    delete data.reportingManager;
    delete data.workLocationType;
    delete data.assignedLocationIds;

    this.employeeService.createEmployee(data).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success', summary: 'Success',
          detail: 'Employee saved successfully.'
        });
        const newEmpId = res?.id;
        if (newEmpId && workLocationType) {
          this.saveEmployeeLocations(Number(newEmpId), workLocationType, assignedLocationIds);
        }
        setTimeout(() => this.router.navigate(['/home/employee-info']), 1000);
      },
      error: () => {
        this.messageService.add({
          severity: 'error', summary: 'Error',
          detail: 'Failed to save Employee.'
        });
      }
    });
  }

  updateEmployee(data: any): void {
    this.submitted = true;
    if (!this.validateForm()) return;

    const workLocationType = data.workLocationType || null;
    const assignedLocationIds = data.assignedLocationIds || [];

    data.empId = Number(this.empId);
    data.updatedBy = localStorage.getItem('username');

    if (data.dob) data.dob = this.getDateOfBirth(data.dob);

    data.WorkLocationType = workLocationType;

    if (Array.isArray(data.reportingManager)) {
      data.reportingManagers = [...data.reportingManager];
      data.reportingManager = data.reportingManager.join(',');
    }

    delete data.workLocationType;
    delete data.assignedLocationIds;

    this.employeeService.updateEmployee(data).subscribe({
      next: () => {
        this.saveEmployeeLocations(Number(this.empId), workLocationType, assignedLocationIds);

        this.messageService.add({
          severity: 'success', summary: 'Success',
          detail: 'Employee updated successfully.'
        });
        setTimeout(() => this.router.navigate(['/home/employee-info']), 1000);
      },
      error: () => {
        this.messageService.add({
          severity: 'error', summary: 'Error',
          detail: 'Failed to update Employee.'
        });
      }
    });
  }

  private saveEmployeeLocations(
    empId: number,
    workLocationType: string | null,
    assignedLocationIds: number[] | null
  ): void {
    const locationIds = (workLocationType === 'Unit' && assignedLocationIds?.length)
      ? assignedLocationIds.map((id: any) => Number(id)).filter(id => !isNaN(id) && id > 0)
      : [];

    const payload = {
      empId: Number(empId),              // FIX: always numeric
      locationIds,
      workLocationType: workLocationType || '',
      createdBy: localStorage.getItem('username') || 'System'
    };

    this.employeeService.assignLocationToEmployee(payload).subscribe({
      next: () => { },
      error: err => console.error('Failed to save employee locations:', err)
    });
  }

  loadLocations(): void {
    this.employeeService.getLocations(this.pageRequest).subscribe({
      next: (res: any) => {
        const all = res?.locations || [];
        this.locations = all;
        this.unitLocations = all.filter((l: any) =>
          (l.locationType || '').toLowerCase() === 'unit'
        );
      },
      error: err => {
        console.error('Failed to load locations:', err);
        this.locations = [];
        this.unitLocations = [];
      }
    });
  }

  getStateList(): void {
    this.customerService.getStateList().subscribe({
      next: (data: any) => (this.stateList = data),
      error: err => console.error(err)
    });
  }

  filterState(event: any): void {
    const query = event.query.toLowerCase();
    this.filterStates = this.stateList.filter(s => s.stateName.toLowerCase().startsWith(query));
  }

  setState(event: any): void {
    this.employeeForm.controls.address.controls.state.setValue(event.value.stateName);
  }

  checkState(): void {
    const entered = this.employeeForm.controls.address.controls.state.value;
    if (!this.stateList.map(s => s.stateName).includes(entered)) {
      this.employeeForm.controls.address.controls.state.setValue('');
    }
  }

  getShift(): void {
    this.employeeService.getShift(this.pageRequest).subscribe({
      next: (data: any) => {
        this.shiftDropdown = (data.employeeShifts || []).map((shift: any) => ({
          ...shift,
          label: `${shift.shiftName} (${this.formatTime(shift.fromTime)} - ${this.formatTime(shift.toTime)})`
        }));
      },
      error: err => console.error(err)
    });
  }

  setShift(event: any): void {
    const selected = this.shiftDropdown.find(s => s.shiftId === event.value);
    if (selected) {
      this.employeeForm.controls['ShiftId'].setValue(selected.shiftId);
      this.employeeForm.controls['ShiftName'].setValue(selected.label);
    }
  }

  formatTime(time: string): string {
    const [hour, minute] = time.split(':').map(Number);
    const period = hour >= 12 ? 'PM' : 'AM';
    const adjusted = hour % 12 || 12;
    return `${adjusted}:${minute.toString().padStart(2, '0')} ${period}`;
  }

  getDesignation(): void {
    this.employeeService.getDesignation({ pageIndex: 0, pageSize: 2000, id: 0 }).subscribe({
      next: (res: any) => {
        const data = res?.designation || [];
        this.DesignationList = data;
        this.designationOptions = data
          .filter((d: any) => d.isActive)
          .map((d: any) => ({ label: d.designationName, value: d.designationName }));
      },
      error: () => {
        this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Failed to load Designation'
        });
      }
    });
  }

  getDateOfBirth(dateInput: Date | string | null | undefined): string | null {
    if (!dateInput) return null;
    const d = new Date(dateInput);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
      `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  validateForm(): boolean {

    if (this.employeeForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please fill all required fields'
      });
      return false;
    }

    const workLocationType = this.employeeForm.value.workLocationType;
    const assignedLocationIds = this.employeeForm.value.assignedLocationIds || [];

    if (workLocationType === 'Unit' && assignedLocationIds.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please assign at least one Unit location.'
      });
      return false;
    }

    return true;
  }

  resetForm(form: FormGroup): void {
    form.reset();
    _.forEach(form.controls, ctrl => ctrl.setErrors(null));
  }

  cancel(): void {
    this.router.navigate(['/home/employee-info']);
  }

  clearFormFields(type: string): void {
    this.isEditMode = false;
    this.selectedType = type;
    this.empId = null;
    this.employeeForm.reset({ employmentType: type, address: { country: 'India' }, IsActive: true });
  }

  get formControls() { return this.employeeForm.controls; }

  focusNextInput(event: Event): void {
    const ke = event as KeyboardEvent;
    ke.preventDefault();
    const target = ke.target as HTMLElement;
    const elements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const idx = elements.indexOf(target);
    if (idx > -1 && idx < elements.length - 1) elements[idx + 1].focus();
  }
}